<template>
  <ul class="topictree-list">
    <!-- topic browse displays -->
    <template v-for="(item, index) in topics">
      <li v-if="unfolded[item]" :style="topicLevel(item)" :key="item"><img alt="blank"
          src="http://www.ikgf.uni-erlangen.de/aigaion2/webcontent/themes/default/icons/tree_blank.gif" class="icon">
        <a>{{item}}</a> &nbsp;&nbsp;<span v-on:click="unFold(index, isFolded(index))">{{isFolded(index)}}</span>
        <!-- <a _v-on:click.stop.prevent="browsebycategory(item)" :href="'http://www.ikgf.uni-erlangen.de/aigaion2/index.php/topics/single/'+(index+1)" :style="'margin-left:'+ ((item.split(' ')[0].replace(/[0-9]*/g,'').length -1)/2 * 20)+'px;'" >{{item}}</a> <template v-if="items[index+1] && ((items[index+1]).split(' ')[0].replace(/[0-9]*/g,'').length >1) && (item.split(' ')[0].replace(/[0-9]*/g,'').length == 1)" ><a href='#' :data="item.split(' ')[0].split('.',2).join('_')" onClick="$('.'+ $(this).attr('data')).toggle(); $(this).text($(this).text()==='+'?'-':'+')">+</a></template> -->
        <!--<span title="read: 0 of 32 publications"><i> 0/32</i></span>-->
      </li>
    </template>
    <!-- End of topic browse displays -->
  </ul>
</template>

<script>
  // @ is an alias to /src
  import fetchJsonp from 'fetch-jsonp'
  import Vue from 'vue'

  export default {
    name: 'topics',
    data: function () {
      return {
        topics: [],
        unfolded: {}
      }
    },
    components: {
    },
    created: async function () {
      let response = await fetchJsonp(`https://crossasia.org/solr/ext-IKGF/select?facet.limit=-1&facet.field=keywords&facet=on&q=*%3A*&rows=0&&wt=json&`, {
        jsonpCallback: 'json.wrf',
      })
      let data = await response.json()
      let categories_ss = data.facet_counts.facet_fields.categories_ss.reduce((acc, obj, index, array) => {
        if (index > 0 && index % 2 == 1) {
          acc[array[index - 1]] = array[index]
        }
        return acc
      }, {})
      // console.log('categories_ss', categories_ss)
      this.topics = Object.keys(categories_ss)
      this.topics.sort((a,b) => {
        let aNums = a.split(" ")[0].split('.')
        let bNums = b.split(" ")[0].split('.')
        
        for (let i = 0; i < 4; i++ ) {
          let aX = parseInt(aNums[i]) || 0
          let bX = parseInt(bNums[i]) || 0
          if (aX !== bX) {
            return aX > bX ? 1 : -1
          }
        }
      })
      // console.log(this.topics)
      this.unfolded = this.topics.reduce((acc, x) => {
        acc[x] = x.split(' ')[0].replace(/[^.]/gm, '').length < 2
        return acc
      }, {})
    },
    methods: {
      topicLevel: function (topic) {
        return `padding-left: ${topic.split(' ')[0].replace(/[^.]/gm, '').length}em`
      },
      isFolded: function(index) {
        let topic = this.topics[index]
        let topicLevel = topic.split(" ")[0].replace(/[^.]/gm, '').length
        let nextTopic = this.topics[index +1] || ""        
        let nextTopicLevel = nextTopic.split(" ")[0].replace(/[^.]/gm, '').length
        if (topic && nextTopic && (nextTopicLevel - topicLevel === 1) ) {
          return !this.unfolded[nextTopic] ? "+" : "-"
        }

        return ''
      },
      unFold: function(index, sign) {
        // console.log(sign)
        let topic = this.topics[index]
        // console.log(index, topic)
        let topicLevel = topic.split(" ")[0].replace(/[^.]/gm, '').length
        for (let i = index + 1; i < this.topics.length; i ++){
          let nextTopic = this.topics[i]
          if (nextTopic) {
            let nextTopicLevel = nextTopic.split(" ")[0].replace(/[^.]/gm, '').length

            if (sign === "+") {
              if (nextTopicLevel - topicLevel === 1) {
                Vue.set( this.unfolded, nextTopic, true )
              
              } else if (nextTopicLevel > topicLevel){
                continue
              } else {
                break
              }
            } else {
              if (nextTopicLevel > topicLevel) {
                Vue.set( this.unfolded, nextTopic, false ) 
              } else {
                break
              }
            } 
          }          
        }
      }
    }
  }
</script>